import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {actions} from "../../store/sliceApp";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {LinkContainer, PageSettingsContainer, TabsBar} from "./PageSettingsStyle";
import {Button, FormControl, InputGroup,} from "react-bootstrap";
import {fetchCreatePublicLink, fetchDeletePublicLink, fetchPublicLinks} from "../../fetch/PublicLinks";
import LinkComponent from "./LinkComponent/LinkComponent";
import {v4 as uuidv4} from 'uuid';
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import {fetchVideoLink, fetchVideoToggleStream, fetchVideoToken} from "../../fetch/RequestVideo";
import {Copy} from "react-bootstrap-icons";
import {Clipboard} from "ts-clipboard";
import {config} from "../../config";


export interface ILinks {
    name: string,
    enable: boolean
}

const PageSettings: FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const [inputValue, setInputValue] = useState('')

    const [links, setLinks] = useState<ILinks[]>([] as ILinks[])
    const [videoLinks, setVideoLinks] = useState<string[]>([])

    useEffect(() => {
        dispatch(actions.clearAll())
        fetchPublicLinks().then(resp => {
            if (resp.isSuccess) {
                setLinks(resp.data)
            }
        })
        fetchVideoLink().then(resp => {
            if (resp.isSuccess) {
                setVideoLinks(resp.data)
            }
        })
    }, [])


    const inputLink = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const text = event.target.value.replace(/[^A-Za-z]/ig, '').replace(" ", '');
        setInputValue(text)
    }, [])


    const createLink = useCallback(() => {
        fetchCreatePublicLink(inputValue).then(resp => {
            if (resp.status === 200) {
                setLinks([...links, resp.data])
                setInputValue('')
            }
        })
    }, [inputValue, links])

    const generateLink = useCallback(() => {
        fetchCreatePublicLink(uuidv4()).then(resp => {
            if (resp.status === 200) {
                setLinks([...links, resp.data])
            }
        })
    }, [inputValue, links])

    const deletePublicLink = useCallback((name: string) => {
        fetchDeletePublicLink(name).then(resp => {
            if (resp.status === 204) {
                setLinks(links.filter(link => link.name !== name))
            }
        })
    }, [links])

    return (
        <PageSettingsContainer>
            <TabsBar defaultActiveKey="files">
                <Tab eventKey="files" title="Файлы">
                    <InputGroup style={{maxWidth: "600px", marginBottom: "10px"}}>
                        <FormControl value={inputValue} onChange={inputLink}/>
                        <Button variant="outline-secondary" onClick={createLink}>
                            Создать
                        </Button>
                        <Button variant="outline-secondary" onClick={generateLink}>
                            Генерировать
                        </Button>
                    </InputGroup>
                    {links.length === 0 && <span>Создайте новую ссылку</span>}
                    {links.map(link => {
                        return <LinkComponent key={link.name} link={link} onDel={() => deletePublicLink(link.name)}/>
                    })}
                </Tab>
                <Tab eventKey="camera" title="Камера">
                    <Button variant="outline-success"
                            onClick={e => {
                                fetchVideoToggleStream(videoLinks.length > 0).then((resp) => {
                                    if (resp.status == 200) {
                                        setVideoLinks([resp.data])
                                    }
                                    if (resp.status == 204) {
                                        setVideoLinks([])
                                    }
                                })
                            }}>
                        {videoLinks.length > 0 ? 'Остановить трансляцию' : 'Запустить трансляцию'}
                    </Button>
                    <LinkContainer>
                    {videoLinks.map(link => {
                        return <>
                            <Copy onClick={() => Clipboard.copy(`${config.url}/camera/api/public/video/stream/${link}`)}/>
                            <div style={{marginLeft: "5px"}}>{ `${config.url}/camera/api/public/video/stream/${link}`}</div>
                            </>
                    })}
                    </LinkContainer>
                </Tab>
            </TabsBar>
        </PageSettingsContainer>

    )
}
export default memo(PageSettings)
